(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import ScrollToTop from '../components/scroll-to-top';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import ImageWebp from '../components/custom/ImageWebp';
import '../assets/styles/components/Amenities.scss';
import 'blueimp-gallery/css/blueimp-gallery.min.css';
const amenitiesMedia = [{
  _id: 'controlled-access',
  name: 'CONTROLLED ACCESS'
}, {
  _id: 'luxer-package-lockers',
  name: 'LUXER PACKAGE LOCKERS'
}, {
  _id: 'study-tables',
  name: 'STUDY TABLES'
}, {
  _id: 'lounge-sitting',
  name: 'LOUNGE SITTING'
}, {
  _id: 'lawn-and-waterfall',
  name: 'LAWN AND WATERFALL'
}, {
  _id: 'bbq-grills',
  name: 'BBQ GRILLS'
}, {
  _id: 'outdoor-dining',
  name: 'OUTDOOR DINING'
}, {
  _id: 'fire-tables',
  name: 'FIRE TABLES'
}, {
  _id: 'bicycle-parking',
  name: 'BICYCLE PARKING'
}];

const ItemGallery = ({
  normal,
  large,
  name
}) => /*#__PURE__*/React.createElement("a", {
  href: large
}, /*#__PURE__*/React.createElement(ImageWebp, {
  src: normal,
  alt: `Amenity ${name}`,
  className: "img-fluid",
  width: "362",
  height: "214",
  title: name
}), /*#__PURE__*/React.createElement("h2", {
  className: "box-shadow"
}, /*#__PURE__*/React.createElement("strong", null, name)));

class Amenities extends React.Component {
  constructor(props) {
    super(props);
    this.amenitieshtml = [];
    const valuesNormal = amenitiesMedia.map(amenity => `/images/amenities/${amenity._id}.webp`);
    const valuesLarge = amenitiesMedia.map(amenity => `/images/amenities/large/${amenity._id}.webp`);

    for (let i = 0; i < amenitiesMedia.length; i++) {
      this.amenitieshtml.push( /*#__PURE__*/React.createElement(ItemGallery, {
        key: i,
        normal: valuesNormal[i],
        large: valuesLarge[i],
        name: amenitiesMedia[i].name
      }));
    }

    this.goBlueimp = this.goBlueimp.bind(this);
  }

  componentDidMount() {
    this.goBlueimp();
  }

  goBlueimp() {
    const Gallery = require('blueimp-gallery');

    document.getElementById('linksgallery').onclick = function (evt) {
      let event = evt;
      event = event || window.event;
      const target = event.target || event.srcElement,
            link = target.parentNode.parentNode,
            options = {
        index: link,
        event
      },
            links = this.getElementsByTagName('a');
      event.preventDefault();
      Gallery(links, options);
    };
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Amenities"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "The District Amenties: GATED, OUTDOOR SEATING, BONFIRE PITS, GRILLING STATIONS, SONOS SPEAKERS, PARKING ONSITE, WIFI IN THE COURTYARD"
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, {
      mode: "nobg"
    }), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Carousel, {
      fade: true,
      className: "slideamenities"
    }, /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities7"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities9"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities11"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities13"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities14"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You")))), /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "amenities15"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "Amenities Catered to You"))))), /*#__PURE__*/React.createElement(Container, {
      className: "content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 mb-5 biglinehd"
    }, /*#__PURE__*/React.createElement("span", null, "Amenities")), /*#__PURE__*/React.createElement("div", {
      className: "listamenities",
      id: "linksgallery"
    }, this.amenitieshtml))), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement("div", {
      id: "blueimp-gallery",
      className: "blueimp-gallery blueimp-gallery-controls"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slides"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "title"
    }), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "prev"
    }, "\u2039"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "next"
    }, "\u203A"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "close"
    }, "\xD7")));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Amenities;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(amenitiesMedia, "amenitiesMedia", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/amenities.jsx");
  reactHotLoader.register(ItemGallery, "ItemGallery", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/amenities.jsx");
  reactHotLoader.register(Amenities, "Amenities", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/amenities.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/amenities.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();